import type { LogLevel } from '@n26/logger'
import { N26FormatterPlugin, N26Logger, ObfuscaterPlugin } from '@n26/logger'
import { clientOnly$, serverOnly$ } from 'vite-env-only'

/**
 * Default logger for client and server code.
 */
export const logger = (function createLogger() {
  let logLevel: LogLevel = getEnv().LOGGER_VERBOSITY
    ? (getEnv().LOGGER_VERBOSITY as LogLevel)
    : 'INFO'

  logLevel = getEnv().ENABLE_CLIENT_SIDE_LOGGING === '1' ? logLevel : 'OFF'

  const plugins =
    getEnv().N26_ENV === 'local'
      ? [] // Locally we want to see plain objects with no filtering at all.
      : [new ObfuscaterPlugin(), new N26FormatterPlugin('nemo')]

  return new N26Logger({
    plugins,
    logLevel,
  })
})()

// Read client-side environment only.
// Make sure server environment code does not end up in the bundle.
function getEnv() {
  const env =
    clientOnly$(window.ENV) ||
    serverOnly$({
      N26_ENV: process.env.N26_ENV,
      LOGGER_VERBOSITY: process.env.LOGGER_VERBOSITY,
      // Enable it by default. Let the Remix root disable it
      // during production builds for client-side logging
      ENABLE_CLIENT_SIDE_LOGGING: process.env.ENABLE_CLIENT_SIDE_LOGGING ?? '1',
    })

  if (!env) {
    throw new Error('ENV not found')
  }

  return env
}
